import { Box } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    group: {
        display: 'flex',
        alignItems: 'center'
    },
    item: {
        color: 'white'
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,

    },
    leftSection: {
        paddingTop: theme.spacing(3),
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'left',
    },
    dialog: {
        overflow: 'auto',
        maxHeight: '60vh',
        '&::-webkit-scrollbar': {
            width: '7px',
            backgroundColor: 'lightgray',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'gray',
            borderRadius: '4px',
            height: '60px'
        },
    }
}));

function HoursReviewTable(props) {
    const { t } = useTranslation('payrollAdjustment');
    const PAGE_SIZE = 20;

    const payrollDetailsColumns = [
        {
            field: 'id',
            headerName: t('driver_id'),
            maxWidth: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.4
        },
        {
            field: 'name',
            headerName: t('driver_name'),
            maxWidth: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
        },
        {
            field: 'semi_hours',
            headerName: t('total_hours'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
        },
    ];

    const rows = Array.isArray(props.houReviewDeatils)
        ? props.houReviewDeatils.map((item) => ({
            id: item.id,
            name: item.name || 'N/A',
            semi_hours: parseFloat(item.semi_hours || 0).toFixed(2), // Keep only two decimal places
        }))
        : [];

    const [selectedItemId, setSelectedItemId] = useState(null);

    return (
        <Box style={{ margin: 30, paddingRight: 40 }}>
            <DataGrid
                columns={payrollDetailsColumns}
                rows={rows || []}
                pagination
                pageSize={PAGE_SIZE}
                rowsPerPageOptions={[PAGE_SIZE]}
                checkboxSelection
                onSelectionModelChange={(newSelection) => {
                    const selectedItems = newSelection.map((itemId) => {
                        const selectedRow = rows.find((row) => row.id === itemId);
                        return {
                            ...selectedRow,
                        };
                    });
                    props.setSelectedItems(selectedItems);
                }}
                loading={props.isDataLoading}
                rowCount={rows?.length || 0}
                style={{ height: '75vh' }}
                getRowClassName={(params) =>
                    params.row.id === selectedItemId ? 'selected-row' : ''
                }
            />
        </Box>
    );
}

export default HoursReviewTable;